import ParagraphText from 'components/text/ParagraphText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardText: FunctionComponent<Props> = props => {
    const { className = '', testId = TEST_ID, text } = props;

    return (
        <ParagraphText className={`${className} ${styles.cardText}`} testId={testId} text={text} />
    );
};

export default CardText;
